import { api } from "./api";
import { GET_NOTES } from "../apiEndPoints";

export const notesApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getNotes: builder.query({
      query: (student_id, coaching_name, course_name, chapter_name) => {
        let URL = `${GET_NOTES}?student_id=${student_id}`;
        if (coaching_name) {
          URL += `&coaching_name=${coaching_name}`;
        }
        if (course_name) {
          URL += `&course_name=${course_name}`;
        }
        if (chapter_name) {
          URL += `&chapter_name=${chapter_name}`;
        }
        return {
          url: URL,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetNotesQuery } = notesApiSlice;
